import Vue from 'vue';
import Router, { RouteConfig } from 'vue-router';
import store from '@/store';
import StoreVuexModule from '@/stores/StoreVuexModule';
import { getModule } from 'vuex-module-decorators';

Vue.use(Router);

const routes: RouteConfig[] = [
  {
    name: '404',
    path: '/404',
    component: () =>
      import(/* webpackChunkName: "404" */ './views/FileNotFound.vue'),
  },
  {
    path: '',
    component: () =>
      import(/* webpackChunkName: "brand" */ './views/Brand.vue'),
    children: [
      {
        name: 'main',
        path: '',
        component: () =>
          import(/* webpackChunkName: "home" */ './views/Home.vue'),
      },
      {
        name: 'orderDetail',
        path: 'orders/:token',
        props: true,
        component: () =>
          import(/* webpackChunkName: "order" */ './views/Order.vue'),
      },
      {
        path: 'orders',
        name: 'orders',
        component: () =>
          import(/* webpackChunkName: "orderList" */ './views/OrderList.vue'),
      },
      {
        path: '*',
        redirect: '/404',
      },
    ],
  },
  {
    name: 'default',
    path: '*',
    redirect: '/404',
  },
];

const storeModule = getModule(StoreVuexModule, store);

const router = new Router({
  mode: 'history',
  routes,
});

router.beforeEach((from, to, next) => {
  // clear auth on each view change.
  storeModule.setRequiredUserRole(null);
  next();
});

export default router;
